<svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg"><path d="m6 0-6 6 6 6 6-6z" fill="#fff"/></svg>